// Color Type core
export function colorTypeCore() {
  const endpoint = '/exteriorcolors/types';
  const detailId = 'exteriorColorTypeId';

  const getDetailId = (data = null) => {
    if (!data) {
      return;
    }

    if (Array.isArray(data)) {
      return data[0][detailId];
    }

    return data[detailId];
  };

  return {
    endpoint,
    detailId,
    getDetailId: getDetailId
  };
}

// Color Type filter
export function colorTypeFilter() {
  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.exteriorColorTypeId
      };

      // Object values
      const objects = {
        label: row.exteriorColorTypeDescription
      };

      // Get the text/value from the default culture
      Object.entries(objects).forEach(([j, prop]) => {
        prop.translations.forEach((culture, k) => {
          if (culture.defaultCulture === true) {
            rows[i][j] = culture.text;
          }
        });
      });
    });

    return rows;
  };

  return {
    getRows: getRows
  };
}
